import Quill from "quill";
let Embed = Quill.import("blots/embed");
import EventBus from "@/assets/js/eventBus.js";

// a simple blot to represent an editor synonym.
class GlobalSynonymBlot extends Embed {
  static create(synonym) {
    let node = super.create();
    node.innerHTML = `<i class="fa-light fa-globe"></i> ${synonym.synonym}`;
    node.setAttribute("title", synonym.synonym);
    node.setAttribute("value", synonym.synonym);
    node.setAttribute("synonym", synonym.synonym);
    if ('formatting' in synonym && synonym.formatting != '') {
      node.setAttribute("formatting", synonym.formatting);
    }
    node.classList.add("global-synonym-blot");
    node.addEventListener("click", (event) => {
      EventBus.$emit("globalSynonymClicked", { node, synonym, event });
    });
    return node;
  }

  //Goes to delta.attributes
  static formats(node) {
    return {
      values: node.getAttribute("value"),
      formatting: node.getAttribute("formatting"),
    };
  }

  //Goes to delta.insert
  static value(node) {
    return {
      synonym: node.getAttribute("value"),
      formatting: node.getAttribute("formatting"),
    };
  }
}

GlobalSynonymBlot.blotName = "globalSynonym";
GlobalSynonymBlot.tagName = "span";
GlobalSynonymBlot.className = "global-synonym-blot-class";

export default GlobalSynonymBlot;
